export const cookieRead = (name) => {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(";").map(cookie => cookie.trim());
  const cookie = cookies.find(cookie => cookie.startsWith(nameEQ));
  return cookie ? cookie.substring(nameEQ.length) : null;
};

export const cookieDelete = (name) => {
	document.cookie = `${name}=; Max-Age=0; path=/;`; // expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=Lax;
};

export const ReadAimCookes = () => {
	const cookies = {};
	const cookiePairs = document.cookie.split(";");

	for (const cookiePair of cookiePairs) {
		const [key, value] = cookiePair.split("=");
		cookies[key.trim()] = value;
	}

	const AimCookies = {
		RuntimeMode: cookies.RuntimeMode,
		RuntimeDeveloper: cookies.RuntimeDeveloper,
		RuntimeClient: cookies.RuntimeClient,
		DevStyles: cookies.DevStyles,
	};
	return AimCookies;
};
